var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.show)?_c('confirm-notification',{attrs:{"activator":!!_vm.show,"notification":_vm.currentNotification},on:{"close":function($event){_vm.show = false}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }